import Login from "./pages/Login/Login";
import Welcome from "./pages/Welcome/Welcome";
import DataAddScreen from "./pages/DataAddScreen/DataAddScreen";
import SSOLogin from "./pages/Login/SSOLogin";
import { createBrowserRouter } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Home from "./pages/Home/Home";
import User from "./pages/User/User";
import LeaveManagement from "./pages/LeaveManagement/LeaveManagement";
import EarnedLeaveRequests from "./pages/LeaveManagement/EarnedLeaveRequests";
import MyEarnedLeaveRequests from "./pages/LeaveManagement/MyEarnedLeaveRequests";
import LeaveSummary from "./pages/LeaveManagement/LeaveSummary";
import Employee from "./pages/Employee/Employee";
import PublicHoliday from "./pages/PublicHoliday/PublicHoliday";
import TaskManagement from "./pages/TaskManagement/TaskManagement";
import BugManagement from "./pages/BugManagement/BugManagement";
import Project from "./pages/Project/Project";
import Client from "./pages/Client/Client";
// import TaskManagementMain from "./pages/TaskManagement/TaskManagementMain";
// import Dums from "./pages/Dummy/Dums";
import AddTask from "./components/TaskManagement/AddTasks";
import TaskDetails from "./pages/TaskManagement/TaskDetails";
import EditEmployee from "./pages/Employee/EditEmployee";
import EmployeeDetails from "./pages/Employee/EmployeeDetails";
import TimeTracker from "./pages/TimeTracker/TimeTracker";
import NoteApprovals from "./pages/TimeTracker/NoteApprovals";
import AppUsageTracking from "./pages/AppUsageTracking/AppUsageTracking";
import ProductivityPage from "./pages/Productivity/ProductivityPage";
import VaultPage from "./pages/Vault/VaultPage";
import VaultRecords from "./pages/Vault/VaultRecords";
import VaultGate from "./pages/Vault/VaultGate";
import Attendance from "./pages/Reports/Attendance";
import ProjectReport from "./pages/Reports/ProjectReport";
import Shifts from "./pages/Shifts/Shifts";
import Reverted from "./pages/Reports/Reverted";
import SupportingFileUpload from "./pages/Client/SupportingFileUpload";
import NewClientTaskManagement from "./pages/Client/NewClientTaskManagement";
import ProjectWorkingReport from "./pages/Reports/ProjectWorkingReport";
import ClientTaskReport from "./pages/Reports/ClientTaskReport";
import ParentTaskReport from "./pages/Reports/ParentTaskReport";
import TaskReport from "./pages/Reports/TaskReport";
import CandidateReportTable from "./pages/Reports/candidateHistory";
import AddParentTask from "./components/ParentTask/AddParentTask";
import ParentTask from "./pages/ParentTask/ParentTask";
import Request from "./pages/Request/Request";
import Manager from "./pages/Manager/Manager";
import DailyWorkingReport from "./pages/Reports/DailyReport";
import ProjectDailyReport from "./pages/Reports/ProjectDailyReport";
import TodoTask from "./pages/TodoTask/TodoTask";
import PermissionManagement from "./pages/PermissionManagement/PermissionManagement";
import withPermission from "./components/Permission/withPermission";
import AppDownloadUpload from "./pages/AppDownloadUpload/AppDownloadUpload";
import SystemMonitoring from "./pages/SystemMonitoring/SystemMonitoring";
import PayrollManagement from "./pages/PayrollManagement/PayrollManagement";
import TimeSheet from "./pages/TimeSheet/TimeSheet";
import IssueWiseReport from "./pages/Reports/IssueWiseReport";
import TimeLoggerOrgs from "./pages/TimeLoggerOrgs/TimeLoggerOrgs";
import TimeLoggerAttendance from "./components/TimeLoggerAttendance/TimeLoggerAttendance";
import HomeIndexRedirect from "./components/HomeIndexRedirect";

// Wrap components with permission checks
const ProtectedDashboard = withPermission(Dashboard, "dashboard", "view");
const ProtectedEmployee = withPermission(Employee, "employee", "view");
const ProtectedManager = withPermission(Manager, "manager", "view");
const ProtectedTaskManagement = withPermission(TaskManagement, "taskManagement", "view");
const ProtectedBugManagement = withPermission(BugManagement, "taskManagement", "view");
const ProtectedTimeSheet = withPermission(TimeSheet, "taskManagement", "view");
const ProtectedParentTask = withPermission(ParentTask, "parentTask", "view");
const ProtectedTodoTask = withPermission(TodoTask, "todoTask", "view");
const ProtectedClient = withPermission(Client, "client", "view");
const ProtectedProject = withPermission(Project, "project", "view");
const ProtectedClientTaskManagement = withPermission(NewClientTaskManagement, "clientTaskManagement", "view");
const ProtectedSupportingFileUpload = withPermission(SupportingFileUpload, "supportingFileUpload", "view");
const ProtectedLeaveManagement = withPermission(LeaveManagement, "leaveManagement", "view");
const ProtectedLeaveSummary = withPermission(LeaveSummary, "leaveManagement", "view");
const ProtectedEarnedLeaveRequests = withPermission(EarnedLeaveRequests, "earnedLeaveRequests", "view");
const ProtectedMyEarnedLeaveRequests = withPermission(MyEarnedLeaveRequests, "myEarnedLeaveRequests", "view");
const ProtectedPublicHoliday = withPermission(PublicHoliday, "publicHoliday", "view");
const ProtectedAttendance = withPermission(Attendance, "attendance", "view");
const ProtectedTimeTracker = withPermission(TimeTracker, "timeTracker", "view");
const ProtectedAppUsage = withPermission(AppUsageTracking, "timeTracker", "view");
// Manager/admin-only queue for slot notes. The page re-checks the role itself —
// employees carry timeTracker.view for their own activity, but must not review.
const ProtectedNoteApprovals = withPermission(NoteApprovals, "timeTracker", "view");
const ProtectedProjectReport = withPermission(ProjectReport, "projectReport", "view");
const ProtectedProjectWorkingReport = withPermission(ProjectWorkingReport, "projectWorkingReport", "view");
const ProtectedClientTaskReport = withPermission(ClientTaskReport, "clientTaskReport", "view");
const ProtectedParentTaskReport = withPermission(ParentTaskReport, "parentTaskReport", "view");
const ProtectedTaskReport = withPermission(TaskReport, "taskreport", "view");
const ProtectedDailyWorkingReport = withPermission(DailyWorkingReport, "dailyWorkingReport", "view");
// ProjectDailyReport - No permission check needed for admins
const ProtectedCandidateHistory = withPermission(CandidateReportTable, "candidateHistory", "view");
const ProtectedReverted = withPermission(Reverted, "reverted", "view");
const ProtectedRequest = withPermission(Request, "request", "view");
const ProtectedShifts = withPermission(Shifts, "shifts", "view");
const ProtectedPayrollManagement = withPermission(PayrollManagement, "payrollManagement", "view");
const ProtectedIssueWiseReport = withPermission(IssueWiseReport, "issuewisereport", "view");

const router = createBrowserRouter([
  {
    path: "",
    errorElement: <p>No Page Found</p>,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        element: <Login />,
        path: "login",
      },
      {
        element: <Welcome />,
        path: "welcome",
      },
      {
        element: <DataAddScreen />,
        path: "data-add-screen",
      },
      {
        element: <SSOLogin />,
        path: "sso-login",
      },

      {
        path: "home",
        element: <Home />,
        children: [
          {
            index: true,
            element: <HomeIndexRedirect />,
          },
          {
            path: "dashboard",
            element: <ProtectedDashboard />,
          },
          {
            path: "user",
            element: <User />,
          },
          {
            path: "employee",
            element: <ProtectedEmployee />,
          },
          {
            path: "employeeDetails",
            element: <EmployeeDetails />,
          },
          {
            path: "Manager",
            element: <ProtectedManager />,
          },
          {
            path: "editEmployee",
            element: <EditEmployee />,
          },
          {
            path: "client",
            element: <ProtectedClient />,
          },
          {
            path: "time-tracker",
            element: <ProtectedTimeTracker />,
          },
          {
            path: "note-approvals",
            element: <ProtectedNoteApprovals />,
          },
          {
            path: "productivity",
            element: <ProductivityPage />,
          },
          {
            path: "vault",
            element: <VaultGate />,
            children: [
              { index: true, element: <VaultPage /> },
              { path: ":masterId", element: <VaultRecords /> },
            ],
          },
          {
            path: "app-usage",
            element: <ProtectedAppUsage />,
          },
          {
            path: "attendance",
            element: <ProtectedAttendance />,
          },
          {
            path: "project",
            element: <ProtectedProject />,
          },
          {
            path: "leaveManagement",
            element: <ProtectedLeaveManagement />,
          },
          {
            path: "leaveSummary",
            element: <ProtectedLeaveSummary />,
          },
          {
            path: "earnedLeaveRequests",
            element: <ProtectedEarnedLeaveRequests />,
          },
          {
            path: "myEarnedLeaveRequests",
            element: <ProtectedMyEarnedLeaveRequests />,
          },
          {
            path: "publicHoliday",
            element: <ProtectedPublicHoliday />,
          },
          {
            path: "DailyWorkingReport",
            element: <ProtectedDailyWorkingReport />,
          },
          {
            path: "ProjectDailyReport",
            element: <ProjectDailyReport />,
          },
          {
            path: "taskManagement",
            element: <ProtectedTaskManagement />,
          },
          {
            path: "bugManagement",
            element: <ProtectedBugManagement />,
          },
          {
            path: "createTask",
            element: <AddTask />,
          },
          {
            path: "taskDetails",
            element: <TaskDetails />,
          },
          {
            path: "addParentTask",
            element: <AddParentTask />,
          },
          {
            path: "parentTask",
            element: <ProtectedParentTask />,
          },
          {
            path: "clientTaskManagement",
            element: <ProtectedClientTaskManagement />,
          },
          {
            path: "request",
            element: <ProtectedRequest />,
          },
          {
            path: "supportingFileupload",
            element: <ProtectedSupportingFileUpload />,
          },
          {
            path: "projectReport",
            element: <ProtectedProjectReport />,
          },
          {
            path: "shifts",
            element: <ProtectedShifts />,
          },
          {
            path: "reverted",
            element: <ProtectedReverted />,
          },
          {
            path: "projectworkingreport",
            element: <ProtectedProjectWorkingReport />,
          },
          {
            path: "clientTaskReport",
            element: <ProtectedClientTaskReport />,
          },
          {
            path: "parenttaskreport",
            element: <ProtectedParentTaskReport />,
          },
          {
            path: "taskreport",
            element: <ProtectedTaskReport />,
          },
          {
            path: "candidateHistory",
            element: <ProtectedCandidateHistory />,
          },
          {
            path: "todoTask",
            element: <ProtectedTodoTask />,
          },
          {
            path: "permissionManagement",
            element: <PermissionManagement />,
          },
          {
            path: "appDownloadUpload",
            element: <AppDownloadUpload />,
          },
          {
            path: "systemMonitoring",
            element: <SystemMonitoring />,
          },
          {
            path: "payrollManagement",
            element: <ProtectedPayrollManagement />,
          },
          {
            path: "timeSheet",
            element: <ProtectedTimeSheet />,
          },
          {
            path: "issuewisereport",
            element: <ProtectedIssueWiseReport />,
          },
          {
            path: "timeLoggerOrgs",
            element: <TimeLoggerOrgs />,
          },
          {
            path: "timeLoggerAttendance",
            element: <TimeLoggerAttendance />,
          },
        ],
      },
    ],
  },
]);

export default router;
